import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {Subject} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {FormBuilder, Validators} from '@angular/forms';
import {Store} from '@ngrx/store';
import {AdminPanelState} from '../../store/reducers/admin-panel.reducer';
import {UserModel} from '../../models/user.model';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
    standalone: false,
    selector: 'lib-update-user',
  templateUrl: './update-user.component.html',
  styleUrls: ['./update-user.component.scss']
})
export class UpdateUserComponent implements OnInit, OnDestroy {

  updateUserForm: any;
  sourceType = 'Admin-Panel';
  updateUserFormErrors: any;
  unSubscribe$ = new Subject<void>();
  result: any;

  constructor(public dialogRef: MatDialogRef<UpdateUserComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private router: Router,
              private activatedRoute: ActivatedRoute,
              private formBuilder: FormBuilder,
              private store: Store<AdminPanelState>) {
    this.updateUserFormErrors = {
      firstName: {},
      lastName: {},
      designation: {},
      isActive: {}
    };
    this.result = {
      user: null,
      save: false
    };
  }

  ngOnInit() {
    this.updateUserForm = this.formBuilder.group({
      firstName: [this.data.user.FirstName.displayText, Validators.required],
      lastName: [this.data.user.LastName.displayText, Validators.required],
      designation: [this.data.user.Designation.displayText],
      isActive: [this.data.user.IsActive.displayText === 'True']
    });

    this.updateUserForm.valueChanges.subscribe(() => {
      this.onFormValueChanged();
    });
  }

  ngOnDestroy(): void {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }

  onFormValueChanged() {
    for (const field in this.updateUserFormErrors) {
      if (!this.updateUserFormErrors.hasOwnProperty(field)) {
        continue;
      }

      this.updateUserFormErrors[field] = {};
      const control = this.updateUserForm.get(field);

      if (control && control.dirty && !control.valid) {
        this.updateUserFormErrors[field] = control.errors;
      }
    }
  }

  onSave() {
    if (this.updateUserForm.valid) {
      this.updateUserForm.controls['firstName'].setValue(this.updateUserForm.controls['firstName'].value.trim());
      this.updateUserForm.controls['lastName'].setValue(this.updateUserForm.controls['lastName'].value.trim());
      this.updateUserForm.controls['designation'].setValue(this.updateUserForm.controls['designation'].value.trim());
      this.updateUserForm.controls['isActive'].setValue(this.updateUserForm.controls['isActive'].value);

      const user = new UserModel({
        firstName: this.updateUserForm.value.firstName,
        lastName: this.updateUserForm.value.lastName,
        companyName: this.data.user.Company.displayText,
        designation: this.updateUserForm.value.designation,
        isActive: this.updateUserForm.value.isActive,
        username: this.data.user.Username.displayText,
        email: this.data.user.Email.displayText,
        companyId: this.data.user.CompanyId.displayText
      });

      this.result.save = true;
      this.result.user = user;
    }
  }
}
